import { render } from "./heroView.vue?vue&type=template&id=81f35248"
import script from "./heroView.vue?vue&type=script&lang=js"
export * from "./heroView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__